import { FEATURES } from '@constants/Text'

/**
 * Este usuário pode conectar o WhatsApp à IA?
 *
 * Espelho EXATO do gate do backend (`aawz_intelligence_v2/whatsapp/core/gate.py`,
 * `FLAGS_EXIGIDAS`): `home_ia` + `IA CRM Chat` + `IA - WhatsApp`. A tela só evita
 * mostrar um item que daria 403 — quem decide é o servidor.
 *
 * Não reutiliza `podeVerIaDriven`: aquela régua gateia por `AAWZ Intelligence`
 * (`FEATURES.CHAT_IA`), que o servidor NÃO consulta aqui. Divergir das flags do
 * backend não dá erro — o item some em silêncio para escritórios que têm direito
 * (achado do review do PR 2315).
 */
export const FLAGS_EXIGIDAS_WHATSAPP = [
  FEATURES.HOME_IA,
  FEATURES.IA_CRM_CHAT,
  FEATURES.IA_WHATSAPP,
]

export function podeConectarWhatsapp({ user, access } = {}) {
  // As rotas do vínculo exigem profissional logado (cliente final recebe 403).
  if ((user || {}).IS_CLIENTE) return false
  const mapa = access || {}
  return FLAGS_EXIGIDAS_WHATSAPP.every((flag) => Boolean(mapa[flag]))
}
